import { useFormContext, useWatch } from 'react-hook-form';
import { getIsSTOEnabled } from 'modules/campaigns/editor/utils';
import { RecurrenceScheduleType } from 'modules/campaigns/lib/types';
import {
  getCampaignRecurrenceScheduleType,
  getIsRecurringScheduleType,
} from 'modules/campaigns/lib/utils';
import { ScheduleFormState } from 'modules/campaigns/editor/types';
import { useEffect } from 'react';
import { useCampaignContext } from '../../../context';
import { EndRecurrenceScheduleTypes } from './EndRecurrenceScheduleTypes';
import { Recurrence } from './Recurrence';
import { RecurrenceFrequency } from './RecurrenceFrequency';
import { SkipOnDays } from './SkipOnDays';
import { SendWithRespectTo } from './SendWithRespectTo';
import { StartDateAndTime } from './StartDateAndTime';
import { PreCreateHours } from './PreCreateHours';
import { RECURRENCE_SCHEDULE_TYPES_WITH_SKIP_ON_DAYS } from '../ScheduleCampaignModal.constants';
import { ProjectTimeZone } from './ProjectTimeZone';

export const ScheduleCampaignForm = () => {
  const { campaign } = useCampaignContext();
  const { dataScienceOptimizations } = campaign;

  const { setValue, trigger } = useFormContext();
  const recurrence = useWatch<Pick<ScheduleFormState, 'recurrence'>>({
    name: 'recurrence',
  });

  const defaultRecurrence = getCampaignRecurrenceScheduleType(campaign);

  useEffect(() => {
    setValue('recurrence', defaultRecurrence);
    trigger();
  }, [setValue, trigger, defaultRecurrence]);

  const isSTOEnabled = getIsSTOEnabled(dataScienceOptimizations);

  const isRecurringScheduleType = getIsRecurringScheduleType(recurrence);
  const isCustomRecurrenceScheduleSelected = recurrence === RecurrenceScheduleType.Custom;
  const isRecurrenceWithSkipOnDaysSelected =
    RECURRENCE_SCHEDULE_TYPES_WITH_SKIP_ON_DAYS.includes(recurrence);

  return (
    <>
      <StartDateAndTime />
      {!isSTOEnabled && <SendWithRespectTo />}
      <Recurrence />
      {isCustomRecurrenceScheduleSelected && <RecurrenceFrequency />}
      {isRecurringScheduleType && <EndRecurrenceScheduleTypes />}
      {isRecurrenceWithSkipOnDaysSelected && <SkipOnDays />}
      {isRecurringScheduleType && <PreCreateHours />}
      {/**
       * NOTE: this is a temp NoOp component that adds the project time zone to the RHF for validations purposes.
       * We plan on removing this in the future */}
      <ProjectTimeZone />
    </>
  );
};
